import { Box, Button, Icon, Spinner, Text, VStack } from "@chakra-ui/react";
import { LottieReact } from "@lottielab/lottie-player";
import { useAppKit } from "@reown/appkit/react";
import { FaHourglassStart } from "react-icons/fa";
import { PiLightningFill } from "react-icons/pi";

import { Countdown } from "@/components/countdown";
import { useAuth } from "@/hooks/useAuth";
import { useDailySpinOnchain } from "@/hooks/useDailySpinOnchain";

export const SpinButton = ({
  handleSpin,
  isSpinning,
}: {
  handleSpin: () => void;
  isSpinning: boolean;
}) => {
  const { hasSpunToday, isLoadingDailySpinStats } = useDailySpinOnchain();
  // TEMPORARY HACK TO TRY TO ENABLE USERS TO SPIN
  // THIS SHOULD BE FINE B/C SPIN REWARDS WILL ALWAYS GO TO THE USER SPINNING
  // SO EVEN IF SOMEONE ELSE SPINS FOR A USER, THE USER WILL STILL GET THE REWARDS
  const { address } = useAuth();
  const { open } = useAppKit();

  const handleButtonClick = () => {
    if (!address) {
      // If not authenticated, open the wallet connection modal
      open();
    } else {
      // If authenticated, proceed with the spin
      handleSpin();
    }
  };

  if (address && isLoadingDailySpinStats)
    return (
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        zIndex={1}
      >
        <Spinner />
      </Box>
    );
  return (
    <Box
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      zIndex={1}
      overflow="hidden"
    >
      {hasSpunToday && !isSpinning ? (
        <Box
          width={["124px", "144px", "164px", "184px"]}
          height={["124px", "144px", "164px", "184px"]}
          bg="bg.muted"
          borderRadius="full"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize={["18px", "20px", "22px", "24px"]}
        >
          <VStack>
            <Text fontSize="12px" color="fg.muted">
              Next Spin:
            </Text>
            <Countdown w={106} textAlign="center" />
          </VStack>
        </Box>
      ) : (
        <Button
          borderRadius="full"
          width={["124px", "144px", "164px", "184px"]}
          height={["124px", "144px", "164px", "184px"]}
          bg="bg.inverted"
          color="fg.inverted"
          transition="transform 0.2s, box-shadow 0.2s"
          onClick={handleButtonClick}
          disabled={isSpinning}
          overflow="hidden"
          position="relative"
        >
          <Icon
            width={["18px", "20px", "22px", "24px"]}
            height={["18px", "20px", "22px", "24px"]}
          >
            {isSpinning ? <FaHourglassStart /> : <PiLightningFill />}
          </Icon>
          {!isSpinning && (
            <LottieReact
              src="https://cdn.lottielab.com/l/eZhi6QmVV33do0.json"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                aspectRatio: "1/1",
                borderRadius: "full",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
              }}
            />
          )}
        </Button>
      )}
    </Box>
  );
};
